import { Heading, Text } from 'react-aria-components';
import { Link } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';

const NotFoundContent = ({ className }: { className?: string }) => (
  <div
    className={twMerge(
      'w-full bg-surface-alt rounded-3xl shadow-3 p-11 text-center',
      className
    )}
  >
    <Heading level={2} className="text-surface-alt-90 text-2xl font-bold">
      Something went wrong!
    </Heading>
    <Text elementType="p" className="text-surface-alt-75 font-medium mt-2 mb-8">
      Page not found!
    </Text>
    <Text
      elementType="p"
      className="text-surface-alt-75 font-medium mt-4 text-center"
    >
      Go back to{' '}
      <Link
        to="/"
        className="text-surface-alt-ghost-75 font-semibold hover:underline"
      >
        Home
      </Link>
    </Text>
  </div>
);

export default NotFoundContent;
